import React from "react";
import Donate from "../../components/donate/Donate";
import Contact from "../../components/contact/Contact";
import Footer from "../../components/footer";
import NavComponent from "../../components/navbar/index";
import OpenForumComponent from "../../components/events/open-forum-events";










const OpenForumEvent = () => {
  return (
    <>
      <NavComponent />
      <div
        style={{
          marginTop: "80px",
        }}
      >
      <OpenForumComponent/>
      </div>
      <div
        style={{
          marginTop: "80px",
        }}
      >
        <Donate />
      </div>
      <Contact />
      <Footer />
    </>
  );
};

export default OpenForumEvent;
